export default __webpack_public_path__ + "static/media/D_Forms.3dd6d7d8.png";